import { makeStyles, tokens } from '@fluentui/react-components';

export const useCartButtonRowStyles = makeStyles({
    root: {
        display: 'flex',
        columnGap: tokens.spacingHorizontalM,
        marginBottom: tokens.spacingVerticalXXXL,
        '@media screen and (max-width: 1100px)': {
            marginBottom: tokens.spacingVerticalXL
        }
    }
});
